import {ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZonelessChangeDetection} from '@angular/core';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {AlertService, loadIndicatorInterceptor} from '@ratespecial/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';
import {PROJECT_CONFIG, ProjectConfig} from 'src/app/project-config';
import {SentryErrorHandler} from 'src/app/shared/errors/sentry-error-handler';
import {serverErrorInterceptor} from 'src/app/shared/interceptor/http/server-error.interceptor';
import {routes} from 'src/app/app-routes';
import {provideStore, Store, withNgxsNoopExecutionStrategy} from '@ngxs/store';
import {SessionState} from 'src/app/shared/state/session.state';
import * as SessionActions from 'src/app/shared/state/session.actions';
import {environment} from 'src/environments/environment';
import {initializeRouteTracking, logoutOnUnauthInterceptor, logtoTokenInterceptor, provideLogtoAuth} from '@ratespecial/logto-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: PROJECT_CONFIG, useValue: ProjectConfig},
    {provide: ErrorHandler, useClass: SentryErrorHandler},
    AlertService,

    provideAppInitializer(initializeRouteTracking()),

    provideStore([SessionState], {developmentMode: !environment.production}, withNgxsNoopExecutionStrategy()),

    provideLogtoAuth({
      ...environment.logto,
      logoutHookFactories: [
        () => {
          const store = inject(Store);
          return () => store.dispatch(new SessionActions.ClearState());
        },
      ],
    }),

    // https://angular.dev/api/router/ExtraOptions#scrollPositionRestoration
    provideRouter(routes, withInMemoryScrolling({scrollPositionRestoration: 'enabled'})),

    provideHttpClient(
      withFetch(),
      withInterceptors([
        loadIndicatorInterceptor,
        logtoTokenInterceptor,
        serverErrorInterceptor,
        logoutOnUnauthInterceptor,
      ])
    ),

    provideZonelessChangeDetection(),
  ],
}
